import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { COMPANY } from '../../lib/site';
import { SplitText, Reveal } from '../fx/Reveal';
import { MagneticButton } from '../fx/MagneticButton';
const points = ['IICRC-certified restoration specialists', 'Direct insurance claim management', 'True 24/7 emergency response', 'Luxury craftsmanship on every rebuild'];
export function AboutSection() {
  return <section className="relative mx-auto max-w-7xl px-6 py-24" data-id="element-139" data-mp="qewq8pxj3ani">
      <div className="grid items-center gap-14 lg:grid-cols-2" data-id="element-140" data-mp="ve9dhbsbajqm">
        {/* Image with floating + glow */}
        <div className="relative" data-id="element-141" data-mp="107ca5ssdy9b1">
          <div className="absolute -inset-6 rounded-[2.75rem] bg-[radial-gradient(circle_at_30%_30%,rgba(45,168,255,0.35),transparent_70%)] blur-2xl" data-id="element-142" data-mp="155nh9vraq5pk" />
          <motion.div className="relative" animate={{
          y: [0, -14, 0]
        }} transition={{
          duration: 7,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-143" data-mp="198tn52ahxuvi">
            <motion.div initial={{
            clipPath: 'inset(0 0 100% 0)'
          }} whileInView={{
            clipPath: 'inset(0 0 0% 0)'
          }} viewport={{
            once: true
          }} transition={{
            duration: 1.1,
            ease: [0.22, 1, 0.36, 1]
          }} className="overflow-hidden rounded-[2.5rem] shadow-glow" data-cursor="image" data-id="element-144" data-mp="19kkf0j8liitp">
              <img src={COMPANY.owner} alt="Owner of Dream Shield Restoration & Construction" loading="lazy" decoding="async" className="h-[520px] w-full object-cover" data-id="element-145" data-mp="1njjsqvukldb3" />
            </motion.div>
            {/* glass overlay stat */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.4,
            duration: 0.8
          }} className="glass-strong absolute -bottom-6 left-6 rounded-3xl px-6 py-4 shadow-glow" data-id="element-146" data-mp="2b8uvgivhdhrv">
              <p className="font-display text-3xl font-bold text-royal" data-id="element-147" data-mp="3lspni8hy7yk2">15+</p>
              <p className="text-xs font-medium uppercase tracking-wider text-slate" data-id="element-148" data-mp="3qtwtc20j6no3">
                Years Restoring Homes
              </p>
            </motion.div>
          </motion.div>
        </div>

        {/* Text */}
        <div data-id="element-149" data-mp="3hsp6cg3gt99b">
          <Reveal data-id="element-150" data-mp="3hua2ub9cb29t">
            <span className="mb-4 inline-flex items-center gap-2 rounded-full border border-royal/20 bg-white/70 px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-royal" data-id="element-151" data-mp="1b291gl0djlc5">
              About Dream Shield
            </span>
          </Reveal>
          <SplitText as="h2" text="Restoring Homes. Protecting Families." className="font-display text-3xl font-bold leading-[1.08] text-navy sm:text-4xl md:text-5xl" data-id="element-152" data-mp="1q592hckmia79" />
          <div className="mt-6 space-y-4" data-id="element-153" data-mp="1yzf9k0jz73li">
            {['Dream Shield was founded on a simple belief: when disaster strikes, families deserve more than a contractor — they deserve a partner who treats their home like their own.', 'Based in Houston, we combine rapid emergency response with the craftsmanship of a luxury construction firm, delivering restorations that feel better than new.'].map((line, i) => <Reveal key={i} delay={0.1 + i * 0.12} data-id="element-154" data-mp="2dvmsyynk80zq" data-mpi={i}>
                <p className="text-base leading-relaxed text-slate" data-id="element-155" data-mp="ni5wbvrfx7sn">{line}</p>
              </Reveal>)}
          </div>

          <ul className="mt-8 grid gap-3 sm:grid-cols-2" data-id="element-156" data-mp="jhc811a35qz8">
            {points.map((p, i) => <Reveal key={p} delay={0.1 + i * 0.08} data-id="element-157" data-mp="kyiym7j46haa" data-mpi={i}>
                <li className="flex items-center gap-3 text-sm font-medium text-navy" data-id="element-158" data-mp="kzu54f3y2353">
                  <CheckCircle2Icon className="h-5 w-5 shrink-0 text-success" data-id="element-159" data-mp="puzop79vj5q0" />
                  {p}
                </li>
              </Reveal>)}
          </ul>

          <Reveal delay={0.3} className="mt-10" data-id="element-160" data-mp="yw7k9hl09sge">
            {/* signature */}
            <svg viewBox="0 0 220 60" className="h-14 w-56 text-navy" fill="none" data-id="element-161" data-mp="2818mapo1zsm">
              <motion.path d="M6 44 C 20 10, 40 10, 44 40 C 48 12, 70 8, 74 44 C 90 20, 110 30, 120 20 M130 24 C 150 10, 168 44, 186 24 C 196 14, 206 20, 214 30" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" initial={{
              pathLength: 0
            }} whileInView={{
              pathLength: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 2,
              ease: 'easeInOut'
            }} data-id="element-162" data-mp="693az0evqryt" />
            </svg>
            <p className="mt-1 text-sm text-slate" data-id="element-163" data-mp="324q0pbnireqd">
              Founder & Lead Restoration Specialist
            </p>
          </Reveal>

          <Reveal delay={0.4} className="mt-8" data-id="element-164" data-mp="2y6sac5i0imle">
            <MagneticButton variant="primary" to="/about" data-id="element-165" data-mp="2t6ecthe1ev1m">
              Meet the Team
            </MagneticButton>
          </Reveal>
        </div>
      </div>
    </section>;
}